import React, {useCallback, useEffect, useState} from 'react';
import {coeffs, getColorClass} from "../utils/utils";

const EditEsts = ({change, marks}) => {
    const [highlighted, setHighlighted] = useState(0);
    const [estimateSelect, setEstimateSelect] = useState("5");
    const [coeffSelect, setCoeffSelect] = useState(Object.keys(coeffs)[0]);
    const [length, setLength] = useState(marks.coeffs.length);

    const handleKey = useCallback((e) => {
        if (e.keyCode === 39) {
            setHighlighted(prev => (prev === length - 1 ? 0 : prev + 1));
        } else if (e.keyCode === 37) {
            setHighlighted(prev => (prev === 0 ? length - 1 : prev - 1));
        }
    }, [length, marks.estimates]);

    function deleteEst() {
        let marks2 = {estimates: [...marks.estimates], coeffs: [...marks.coeffs], dates: [...marks.dates], workTypes: [...marks.workTypes]};
        marks2.estimates.splice(highlighted, 1)
        marks2.coeffs.splice(highlighted, 1)
        marks2.dates.splice(highlighted, 1)
        marks2.workTypes.splice(highlighted, 1)
        setHighlighted(prev => Math.max(0, prev-1))
        change(marks2)
        setLength(marks2.coeffs.length)
    }

    function addEstToEnd() {
        change({
            estimates: marks.estimates.concat(Number(estimateSelect)),
            coeffs: marks.coeffs.concat(coeffs[coeffSelect]),
            dates: marks.dates.concat("добавлено"),
            workTypes: marks.workTypes.concat(coeffSelect)
        })
        setLength(marks.coeffs.length+1)
    }
    function addEstToStart() {
        let marks2 = {estimates: [...marks.estimates], coeffs: [...marks.coeffs], dates: [...marks.dates], workTypes: [...marks.workTypes]};
        marks2.estimates.unshift(Number(estimateSelect))
        marks2.coeffs.unshift(coeffs[coeffSelect])
        marks2.dates.unshift("добавлено")
        marks2.workTypes.unshift(coeffSelect)
        setHighlighted(prev => prev+1)
        change(marks2)
        setLength(marks2.coeffs.length)
    }
    function addEstBef() {
        let marks2 = {estimates: [...marks.estimates], coeffs: [...marks.coeffs], dates: [...marks.dates], workTypes: [...marks.workTypes]};
        marks2.estimates.splice(highlighted + 1, 0, Number(estimateSelect))
        marks2.coeffs.splice(highlighted + 1, 0, coeffs[coeffSelect])
        marks2.dates.splice(highlighted + 1, 0, "добавлено")
        marks2.workTypes.splice(highlighted + 1, 0, coeffSelect)
        change(marks2)
        setLength(marks2.coeffs.length)
    }

    useEffect(() => {
        document.body.addEventListener('keydown', handleKey);
        return () => {
            document.body.removeEventListener('keydown', handleKey);
        };
    }, [handleKey]);
    return (
        <div className="list-edit">
            <div className="list block">
                <div style={{fontFamily: "Source_Sans3_bold, sans-serif", fontSize: "20px"}}>Список всех оценок по предмету:</div>
                {marks.estimates.length >= 1 &&
                    <span>Выделенная оценка: <span className={getColorClass(marks.estimates[highlighted])} style={{fontFamily: "Source_Sans3_bold"}}>{marks.estimates[highlighted]}</span>&nbsp;за<br/> <span style={{fontFamily: "Source_Sans3_bold"}}>{marks.workTypes[highlighted]}</span>&nbsp;<span style={{fontFamily: "Source_Sans3_bold"}}>({marks.dates[highlighted]})</span></span>
                }
                <div className="list-ests" style={{marginTop: "5px"}}>
                    {marks.estimates.length >= 1 ? Object.keys(marks.estimates).map((key) => {
                            const est = marks.estimates[key];
                            let classEst = getColorClass(est);
                            if (Number(key) === highlighted) classEst += " changed";
                            return (
                                <span key={key}>
                                    <span title={marks.workTypes[key]} onClick={() => setHighlighted(Number(key))} className={classEst}>
                                        {est}
                                    </span>
                                    {(Number(key) + 1 < marks.estimates.length) && <span className="after"></span>}
                                </span>
                            );
                        })
                        : <span style={{fontFamily: "Source_Sans3_bold, sans-serif", color: "var(--gray2-color)"}}>нет оценок</span>}
                </div>
            </div>
            <div className="edit-ests block">
                <div style={{fontFamily: "Source_Sans3_bold, sans-serif", fontSize: "20px"}}>Изменить список оценок:</div>
                <form onSubmit={(e) => e.preventDefault()}>
                    <div id="labels">
                        <label>
                            Выберите оценку:
                            <select name="estimate" value={estimateSelect} onChange={(e) => setEstimateSelect(e.target.value)}>
                                <option value="5">5</option>
                                <option value="4">4</option>
                                <option value="3">3</option>
                                <option value="2">2</option>
                                <option value="1">1</option>
                            </select>
                        </label>
                        <label>
                            За что оценка?
                            <select name="coeff" value={coeffSelect} onChange={(e) => setCoeffSelect(e.target.value)}>
                                {Object.keys(coeffs).map(key => {
                                    return <option key={key} value={key}>{key}</option>
                                })}
                            </select>
                        </label>
                    </div>
                    <div className="buttons">
                        <button disabled={marks.estimates.length <= 0} onClick={deleteEst}>Удалить выделенную оценку</button>
                        <button onClick={addEstToEnd}>Добавить оценку в конец</button>
                        <button onClick={addEstBef}>Добавить оценку перед выделенной</button>
                        <button onClick={addEstToStart}>Добавить оценку в начало</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditEsts;